import loadSessionModule from './modules/Session.module';
const loadNewsletterSubscribeModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule()],
});
export default loadNewsletterSubscribeModule;
